import { Trans } from "react-i18next";import { CalendarIcon } from "lucide-react";
import { cn } from "../../../lib/utils";

function formatDays(value) {
  const label = value === 1 ? "Day" : "Days";
  return `${value.toFixed(1)} ${label}`;
}

export function BalanceDurationBar({ duration, balanceError, overlapError }) {
  const showDuration = duration !== null;
  const durationHasError =
  duration === "Invalid Combination" || Boolean(overlapError);

  if (!showDuration && !balanceError && !overlapError) {
    return null;
  }

  return (
    <div className="space-y-1">
    {showDuration &&
      <div
        className={cn(
          "rounded-lg border px-3 py-2 font-sans",
          durationHasError ?
          "bg-error/10 border-error/20 text-error" :
          "bg-primary/5 border-primary/10 text-primary/80"
        )}>
        
        <div className="flex items-center gap-2">
  <div
            className={cn(
              "h-6 w-6 rounded-md grid place-items-center shrink-0",
              durationHasError ?
              "bg-error/15" :
              "bg-primary/10"
            )}>
            
    <CalendarIcon className="h-3 w-3" />
  </div>

  <span className="text-xs font-medium"><Trans i18nKey="dateTime.duration3" /></span>

  <span
            className={cn(
              "text-sm font-bold",
              durationHasError ?
              "text-error" :
              "text-primary"
            )}>
            
    {duration === "Invalid Combination" ?
            "Invalid Combination" :
            formatDays(duration)}
  </span>
</div>
      </div>
      }

    {balanceError &&
      <p className="text-xs font-medium text-error">
        {balanceError}
      </p>
      }

    {overlapError &&
      <p className="text-xs font-medium text-error">
        {overlapError}
      </p>
      }
  </div>);

}
